<main class="mx-auto max-w-lg p-6">
  <h1 class="mb-4 text-lg font-medium text-gray-800 dark:text-gray-100">멤버 선택</h1>

  @if (state() === 'loading') {
    <div class="flex justify-center py-12">
      <mat-spinner diameter="40" />
    </div>
  } @else if (state() === 'error') {
    <p class="text-center text-red-600 dark:text-red-400">{{ errorMessage() }}</p>
  } @else if (done()) {
    <p class="text-center text-gray-500 dark:text-gray-400">선택이 완료됐습니다. 이 창은 닫아도 됩니다.</p>
  } @else if (ctx(); as ctx) {
    <div class="flex flex-col gap-6">
      <section>
        <h2 class="mb-2 text-sm font-semibold text-gray-800 dark:text-gray-100">팀(반/학년)</h2>
        <ul class="space-y-1 text-sm">
          <li>
            <mat-checkbox
              [checked]="selectedTeamIds().has(rootTeamId)"
              (change)="toggleTeam(rootTeamId)"
            >
              (직속 — 팀 없음)
            </mat-checkbox>
          </li>
          @for (row of teamRows(); track row.id) {
            <li>
              <mat-checkbox [checked]="selectedTeamIds().has(row.id)" (change)="toggleTeam(row.id)">
                <span class="whitespace-pre font-mono">{{ row.prefix }}</span>{{ row.name }}
              </mat-checkbox>
            </li>
          }
        </ul>
      </section>

      @if (availableLabels().length > 0) {
        <section>
          <h2 class="mb-2 text-sm font-semibold text-gray-800 dark:text-gray-100">라벨</h2>
          <ul class="flex flex-wrap gap-2 text-sm">
            @for (label of availableLabels(); track label.id) {
              <li>
                <mat-checkbox [checked]="selectedLabelIds().has(label.id)" (change)="toggleLabel(label.id)">
                  {{ label.name }}
                </mat-checkbox>
              </li>
            }
          </ul>
        </section>
      }

      @if (errorMessage(); as err) {
        <p class="text-sm text-red-600 dark:text-red-400">{{ err }}</p>
      }

      <button
        mat-flat-button
        color="primary"
        [disabled]="!canConfirm() || confirming()"
        (click)="confirm()"
      >
        {{ confirming() ? '확정 중…' : '선택 확정' }}
      </button>
    </div>
  }
</main>
